import { render, staticRenderFns } from "./invitation-xp.vue?vue&type=template&id=3a9b45de&"
import script from "./invitation-xp.vue?vue&type=script&lang=js&"
export * from "./invitation-xp.vue?vue&type=script&lang=js&"
import style0 from "./invitation-xp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports